import { useContext } from 'react';
import { SupervisorContext } from '@/contexts/SupervisorContext';
import { Typography, Stack } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import { formatClientOrSupervisor } from '@/utils/supervisor';

const SupervisorHeaderText = ({ headerText = 'Supervising' }: { headerText?: string }) => {
  const { currentClient } = useContext(SupervisorContext);
  const { t } = useTranslation();

  return (
    <Stack direction="column" alignItems="center">
      <Typography variant="h6" component="p">
        {t(headerText)}
      </Typography>
      <Stack direction="row" alignItems="center" spacing={0.25}>
        <Typography variant="body1" component="p">
          {formatClientOrSupervisor(currentClient)}
        </Typography>
        <ArrowDropDownIcon fontSize="small" />
      </Stack>
    </Stack>
  );
};

export default SupervisorHeaderText;
